import {Link} from 'react-router-dom'
import { QueryState} from '../../_metronic/helpers'
import {Permission} from '../CustomComponents'
import {Filter, FilterFieldProps} from './Filter'
import { Plus } from 'lucide-react'

type Props = {
  title: string
  isLoading: boolean
  updateState: (updates: Partial<QueryState>) => void
  fields?: (FilterFieldProps | string)[]
  filterMode?: 'apply' | 'instant'
  extras?: {
    title: string
    onClick?: () => void
    isLoading?: boolean
    icon?: string
  }[]
  createAble?: boolean
  customCreatePath?: string
}

export const Toolbar = ({createAble = true, ...props}: Props) => {
  return (
    <div className='flex justify-end flex-wrap gap-2' data-kt-academic-year-table-toolbar='base'>
      {props.fields?.length ? (
        <Filter
          isLoading={props.isLoading}
          updateState={props.updateState}
          fields={props.fields}
          mode={props.filterMode}
        />
      ) : null}

      {props.extras?.map((item, index) => (
        <button
          key={index}
          type='button'
          className='relative inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed'
          onClick={item.onClick}
          disabled={item.isLoading}
          data-kt-indicator={item.isLoading ? 'on' : 'off'}
        >
          <span className={item.isLoading ? 'invisible' : 'flex items-center'}>
            {item.icon && <i className={`${item.icon} mx-2 text-base`}></i>}
            {item.title}
          </span>
          {item.isLoading && (
            <span className='absolute inset-0 flex items-center justify-center'>
              <svg
                className='animate-spin h-5 w-5 text-white'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
              >
                <circle
                  className='opacity-25'
                  cx='12'
                  cy='12'
                  r='10'
                  stroke='currentColor'
                  strokeWidth='4'
                />
                <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8v8H4z' />
              </svg>
            </span>
          )}
        </button>
      ))}

      {createAble && (
        <Permission permission='is_add'>
          <Link
            to={props.customCreatePath || 'create'}
            className='inline-flex items-center gap-2 px-4 py-2 bg-[#008080] text-white text-sm font-medium rounded-md hover:bg-[#007373] focus:outline-none focus:ring-2 focus:ring-[#008080]'
          >
            <Plus className='w-5 h-5' />
            Add {props.title}
          </Link>
        </Permission>
      )}
    </div>
  )
}
